import { Dialog } from "primereact/dialog";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { confirmDialog } from "primereact/confirmdialog";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import OrdenesComprasReporte1 from "../../ERP/Compras/OrdenesCompras/Reporte/OrdenesComprasReporte1";


const ModalCuentasEnTransito = ({showDialog, setShowDialog, data, AsignarCuentaEnTransito}) => {
    const toast = useRef(null);
    const [loading, setLoading] = useState(false)
    const [showDialogReporte, setShowDialogReporte] = useState(false)
    const [selectedDetalle, setSelectedDetalle] = useState([])
    const { userAuth } = useContext(AuthContext);


    const columns = [
      {
        field: "IdIngreso",
        header: "Id",
        headerEn: "Id",
        className: "Xsmall",
        width: 60,
        hidden: userAuth?.IdRol === 1,
      },
      {
        field: "NumeroIngreso",
        header: "No. Ingreso",
        headerEn: "No. Ingreso",
        className: "Xsmall",
        Format: "Center",
      },
      {
        field: "PurchaseOrder",
        header: "Orden de compra",
        headerEn: "Purchase Order",
        className: "Xsmall",
        Format: "Center",
        onCellDoubleClicked: ({ data }) => {
            if (data.PurchaseOrder) {
                setShowDialogReporte(true)
                setSelectedDetalle([data])
            }
        }
      },
      {
        field: "FechaFactura",
        header: "Fecha",
        headerEn: "Date",
        Format: "Date",
      },
      {
        field: "Factura",
        header: "Documento",
        headerEn: "Document",
        className: "medium",
        Sumary: "count",
      },
      {
        field: "CustomerName",
        header: "Proveedor",
        headerEn: "Supplier",
        className: "Xlarge",
      },
      {
        field: "Comentarios",
        header: "Comentario",
        headerEn: "Comment",
        className: "XXlarge",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "MontoL",
        header: "Costo L",
        headerEn: "Cost L",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
        frozen: true,
        alignFrozen: "right",
      },
      {
        field: "MontoD",
        header: "Costo $",
        headerEn: "Cost $",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
        frozen: true,
        alignFrozen: "right",
      },
      {
        field: "Id",
        header: "",
        headerEn: "",
        tooltip: "",
        Format: "Botones",
        frozen: true,
        alignFrozen: "right",
        Botones: [
          {
            icon: "pi pi-check",
            tooltip: "Agregar",
            onClick: (e) => {
              confirmDialog({
                message: "¿Está seguro que desea agregar este registro?",
                header: "Confirmación",
                icon: "pi pi-exclamation-triangle",
                accept: (n) => {
                    setLoading(true)
                    AsignarCuentaEnTransito(e)
                    setTimeout(() => {
                        setLoading(false)
                        setShowDialog(false)
                    }, 500);
                },
                reject: () => console.log("Cancelado"),
              });
            },
          },
        ],
      },
    ];

    const table = {
      Data: data,
      Columns: columns,
      loading: loading,
    };

    return (
      <Dialog header="Cuenta de tránsito" visible={showDialog} onHide={() => setShowDialog(false)}>
            <div style={{ height: 300, width: '65vw' }}>
                <AgGrid table={table} />
            </div>

            {showDialogReporte && (
                <OrdenesComprasReporte1
                    showReporte={showDialogReporte}
                    setShowReporte={setShowDialogReporte}
                    selectedDetalle={selectedDetalle}
                    Language={'es'}
                    setLanguaje={() => {}}
                />
            )}
      </Dialog>
    );
}
export default ModalCuentasEnTransito;